import { render, staticRenderFns } from "./delivery-driveteks.vue?vue&type=template&id=572c9876"
import script from "./delivery-driveteks.vue?vue&type=script&lang=js"
export * from "./delivery-driveteks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports